import React from "react";
import PropTypes from "prop-types";
import { DropTarget } from "react-dnd";
import { TYPE } from "./CardDND";
import { Row, Col, Icon } from "antd";

const boxTarget = {
  drop() {
    return { name: "Dustbin" };
  }
};

export class Dustbin extends React.Component {
  static propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    isOver: PropTypes.bool.isRequired,
    canDrop: PropTypes.bool.isRequired
  };

  render() {
    const { canDrop, isOver, connectDropTarget } = this.props;
    const isActive = canDrop && isOver;

    return (
      connectDropTarget &&
      connectDropTarget(
        <div className="ant-row">
          <Col xs={{ span: 24 }}>
            <div>
              {this.props.children.length === 0 ? (
                //nothing
                <div>
                  <Row>
                    <Col className="area-content-dropTarget" xs={{ span: 24 }}>
                      <Row> {this.props.children} </Row>
                      <Row style={{ textAlign: "center" }}>
                        {isActive ? (
                          <Row
                            style={{ marginTop: "20px", marginBottom: "20px" }}
                          >
                            <Row className="area-dragDrop-icon">
                              <Icon type="check" />
                            </Row>
                            <Row>
                              <p style={{ textTransform: "uppercase" }}>
                                Relâchez pour déposer l'événement séléctionné
                              </p>
                            </Row>
                          </Row>
                        ) : (
                          <Row>
                            <Row className="area-dragDrop-icon">
                              <Icon type="inbox" />
                            </Row>
                            <Row>
                              <p style={{ textTransform: "uppercase" }}>
                                Séléctionnez un événement et déposez le ici
                              </p>
                            </Row>
                          </Row>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </div>
              ) : (
                //some card
                <div>
                  <Row type="flex" justify="space-around" align="middle">
                    <Col
                      className="area-content-dropTarget"
                      xs={{ span: 22, offset: 0 }}
                    >
                      <Row type="flex" justify="space-around">
                        {" "}
                        {this.props.children}{" "}
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        {isActive ? (
                          <Row
                            style={{ marginTop: "20px", marginBottom: "20px" }}
                          >
                            <Row className="area-dragDrop-icon">
                              <Icon type="check" />
                            </Row>
                            <Row>RELÂCHER POUR DÉPOSER LES ITEMS</Row>
                          </Row>
                        ) : (
                          <Row>
                            <Row className="area-dragDrop-icon">
                              <Icon type="inbox" />
                            </Row>
                            <Row>CLIQUER ET DÉPOSER LES ITEMS</Row>
                          </Row>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Col>
        </div>
      )
    );
  }
}

export default DropTarget(TYPE.BOX, boxTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))(Dustbin);



// WEBPACK FOOTER //
// ./src/features/admin/events/item/ContainerDND.js